/**
 * Validates a redirect path is safe (same-origin, relative) to prevent
 * open-redirect attacks. Returns the fallback if the path is unsafe.
 */
export function safeRedirect(
  redirect: string | undefined | null,
  fallback: string
): string {
  if (!redirect) return fallback;

  // Must start with exactly one slash (not //) to prevent protocol-relative URLs
  if (!redirect.startsWith('/') || redirect.startsWith('//')) return fallback;

  return redirect;
}
